import { MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function LocalSupport() {
  return <section id="localsupport" className="dark relative py-24 lg:py-32 bg-background overflow-hidden flex flex-col items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 radiating-pattern opacity-30 pointer-events-none mix-blend-screen" />

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex flex-col items-center text-center max-w-4xl">
        {}
        <div className="w-24 h-1.5 bg-gradient-to-r from-[#C79100] to-[#E6B800] mb-8 rounded-full shadow-[0_0_10px_rgba(199,145,0,0.5)]" />

        <h2 className="font-sans font-extrabold text-5xl md:text-7xl tracking-tighter uppercase text-foreground mb-6 drop-shadow-lg">
          Local Support
        </h2>

        <p className="body-text text-muted-foreground text-lg md:text-2xl max-w-2xl mb-12 leading-relaxed">Proudly based in Gloucester. We help local firms in the Gloucestershire, Cardiff and beyond dominate their local market. Call or WhatsApp us at <span className="text-foreground font-bold whitespace-nowrap" data-ast-id="f:/src/pages/Home/sections/LocalSupport.tsx|sig:2jhpzg" data-ast-start="1192" data-ast-end="1273">01452 941841</span> to chat with the team.</p>

        <div className="flex flex-col sm:flex-row gap-6 w-full sm:w-auto justify-center">
          <Button asChild size="lg" className="btn-primary text-lg h-14 px-8 shadow-[6px_6px_0px_0px_rgba(0,0,0,0.8)] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,0.8)] transition-all border border-primary/20">
            <Link to="tel:01452941841">
              <Phone className="mr-2 size-5" />
              Call Us
            </Link>
          </Button>

          <Button asChild size="lg" className="btn-primary text-lg h-14 px-8 shadow-[6px_6px_0px_0px_rgba(0,0,0,0.8)] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,0.8)] transition-all border border-primary/20">
            <Link to="https://wa.me/441452941841" newTab>
              <MessageCircle className="mr-2 size-5" />
              WhatsApp Us
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}